import { keyframes } from '@emotion/react'

const spin = keyframes({
  from: {
    transform: 'rotate(0deg)',
  },
  to: {
    transform: 'rotate(360deg)',
  },
})

const blink = keyframes({
  '0%': {
    opacity: 1,
  },
  '50%': {
    opacity: 0.5,
  },
  '100%': {
    opacity: 1,
  },
})

const ellipsis = keyframes({
  '0%': {
    content: '"."',
  },
  '33%': {
    content: '".."',
  },
  '66%': {
    content: '"..."',
  },
  '100%': {
    content: '"."',
  },
})

const pulseGlow = keyframes({
  '0%': {
    boxShadow: '0 0 4px rgba(252, 76, 30, 0.4)',
  },
  '50%': {
    boxShadow: '0 0 12px rgba(252, 76, 30, 0.8)',
  },
  '100%': {
    boxShadow: '0 0 4px rgba(252, 76, 30, 0.4)',
  },
})

// Stronger pulse for button only
const pulseGlowStrong = keyframes({
  '0%': {
    boxShadow: '0 0 8px 2px rgba(252, 76, 30, 0.6)',
    transform: 'scale(1)',
    opacity: 1,
  },
  '40%': {
    boxShadow: '0 0 32px 12px rgba(252, 76, 30, 1)',
    transform: 'scale(1.1)',
    opacity: 0.85,
  },
  '60%': {
    boxShadow: '0 0 40px 16px rgba(252, 76, 30, 1)',
    transform: 'scale(1.12)',
    opacity: 0.9,
  },
  '100%': {
    boxShadow: '0 0 8px 2px rgba(252, 76, 30, 0.6)',
    transform: 'scale(1)',
    opacity: 1,
  },
})

export const animations = {
  spin,
  blink,
  ellipsis,
  pulseGlow,
  pulseGlowStrong,
}
